/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars*/

// version 1.0.4, release 02.02.2024
// ----------------------------------------------------------------------------

import React, { useState, useEffect, useRef, memo, useReducer, useLayoutEffect, useMemo } from "react";
import ReactDOM from 'react-dom';
import './ui-controls.scss';
import './ui-spinner.scss';
import Sys from "../utils/SystemUtils";
import PointerControl from "../views/dragview/PointerControl";
import PageView_ from './PageView';
import TreeView_ from './TreeView';
import LogView_ from "./LogView";
import Divider from "./Divider";
import TableView_ from "./TableView";
import { createVideoMap } from '../utils/GraphicUtils';
import { ImageLoader } from './ui-lib';
import JsonView2 from "../views/jsonview/JsonView2";

// import { proxy, useProxy } from 'valtio';	//https://github.com/pmndrs/valtio
const shell = window.require? window.require('electron').shell : null;

const timers = {count:0, interval:null, fncs:{}}


const setTimer = fnc => {
	let i = timers.count ++;
	timers.fncs[i] = fnc;

	if (i <= 0){
		console.log('---start intervals ...');
		let diff = 1000 - Date.now() % 1000	//ms till next full second

		setTimeout(e => {
			Object.values(timers.fncs).forEach(f => f());	//first start

			timers.interval = setInterval(e => {
				Object.values(timers.fncs).forEach(f => f());
			}, 1000);
		}, diff + 1)
	}
	return i;
}

const clearTimer = i => {
	if (!timers.fncs[i]) return;
	delete timers.fncs[i];
	timers.count --;

	if (timers.count === 0){
		console.log('---all intervals closed!')
		clearInterval(timers.interval);
	}
}


export const F1 = props => {
	return <div className='ui2-flex f1' styles={getStyles(props)}>{props.children}</div>
}

export const F2 = props => {
	return <div className='ui2-flex f2' styles={getStyles(props)}>{props.children}</div>
}

export const F3 = props => {
	return <div className='ui2-flex f3' styles={getStyles(props)}>{props.children}</div>
}

export const F4 = props => {
	return <div className='ui2-flex f4' styles={getStyles(props)}>{props.children}</div>
}


//----------------------------------------------------------------------------- DragView
export const DragView = props => {
	const viewRef = useRef();
	const control = useRef();
	const rect = useRef()

	useEffect(() => {rect.current = props.rect}, [props.rect])

	useEffect(() => {
		let pos;
		let scale = 1
		let vc = viewRef.current

vc.style.transformOrigin = '0 0'
// vc.style.transition = '0.2s'

vc.addEventListener('mousewheel', e => {
	let bound = vc.getBoundingClientRect()
	// console.log(bound, e)

	let s = e.wheelDelta > 0? 1.1 : 1/1.1
	scale *= s

	pos = [e.clientX - bound.x, e.clientY - bound.y];

	let diff = [pos[0] * (1-s) / 0.75, pos[1] * (1-s) / 0.75]

	vc.style.left = (vc.offsetLeft + diff[0]) + 'px'
	vc.style.top = (vc.offsetTop + diff[1]) + 'px'

	vc.style.transform = 'scale(' + scale + ')'
});
		
		control.current = new PointerControl(vc, {
			// scale : props.scale || 1,
			scale : props.scale,
			includes : props.includes,
			excludes : props.excludes,

			onDown : e => {
				pos = [vc.offsetLeft, vc.offsetTop];
				// pos = [vc.scrollLeft, vc.scrollTop];
				// let x0 = Number(vc.style.left.split('px')[0]) || 0
				// let y0 = Number(vc.style.top.split('px')[0]) || 0
				// pos = [x0, y0];
			},

			onDrag : e => {
				/*
				if (props.dragH || !props.dragV){
					// vc.scrollLeft = pos[0] - e.drag.x					
					vc.style.left = (pos[0] + e.drag.x) + 'px'
				}
				if (props.dragV || !props.dragH){
					// vc.scrollTop = pos[1] - e.drag.y
					vc.style.top = (pos[1] + e.drag.y) + 'px'
				}
				*/
	
				let bound = vc.getBoundingClientRect()
				if (props.dragH || !props.dragV){
					let px = pos[0] + e.drag.x
					if (rect.current){
						px = Math.max(rect.current[0], Math.min(rect.current[1] - bound.width, px))
					}
					vc.style.left = px + 'px'
				}
				if (props.dragV || !props.dragH){
					let py = pos[1] + e.drag.y
					if (rect.current){
						py = Math.max(rect.current[2], Math.min(rect.current[3] - bound.height, py))
					}
					vc.style.top = py + 'px'
				}
			}
		})
		props.onLoad?.(viewRef)

		return () => {
			control.current.clearEvents();
		};
	}, [])

	return (
		<div id={props.id}
			className={'ui2-drag-view' +  (props.className? ' ' + props.className : '')}
			ref={viewRef}
			style={props.style}
			>
			{props.children}
		</div>
	)
}


//----------------------------------------------------------------------------- Code
export const Code = props => {
	const [source, setSource] = useState()

	useEffect(() => setSource(props.source), [props.source])

	return <div className="ui2-code" style={getStyles(props)}>
		<pre>
			<code>
				{JSON.stringify(source, null, 2) }
			</code>
		</pre>
	</div>
}


//----------------------------------------------------------------------------- HeaderBar
export const HeaderBar = props => {
	return <div className='ui2-header'>
		{props.title &&
			<div className='ui2-header-title'>{props.title}<span>{props.subTitle}</span></div>
		}
		{props.buttons &&
			<ButtonBar content={props.buttons} onSelect={props.onSelect} />
		}

		{(props.mode && process?.env?.NODE_ENV) &&
			<div className={'ui2-header-mode ' + (process.env.NODE_ENV === 'development'? 'dev' : 'life')}>
				{process.env.NODE_ENV === 'development'? 'DEV' : 'LIFE'}
			</div>
		}

		{props.dateTime && <UIDateTime className='ui2-header-datetime' />}

		{props.children}
	</div>
}


//----------------------------------------------------------------------------- CloseButton
export const CloseButton = props => {
	return <div className='ui2-close'
		id={props.id}
		onClick={props.onClick}
		style={getStyles(props)}
	>✖</div>
}


//----------------------------------------------------------------------------- UIDateTime
export const UIDateTime = props => {
	const [time, setTime] = useState(e => Sys.getDateTime())

	useEffect(() => {
		let i = setTimer(e => setTime(Sys.getDateTime()))

		return e => {
			clearTimer(i);
		}
	}, [])

	return <div id={props.id} className={props.className} style={props.style}>{time}</div>
}


//----------------------------------------------------------------------------- UIPlayTime
export const UIPlayTime = props => {
	const [time, setTime] = useState(e => Sys.getPlayTime())

	useEffect(() => {
		let i = setTimer(e => {
			setTime(Sys.getPlayTime())
		})

		return e => {
			clearTimer(i);
		}
	}, [])

	return <div>{time}</div>
}



//----------------------------------------------------------------------------- DebugView
// <UICounter label='next update:' count={30} onComplete={checkUpdate} autoStart={true} />
//
export const UICounter = props => {
	const [setup] = useState(e => {
		let s = props.setup || {};
		s.label = props.label ?? s.label;
		s.autoStart = props.autoStart ?? s.autoStart ?? true;
		s.count = props.count ?? s.count;
		s.onComplete = props.onComplete ?? s.onComplete;
		s.onRun = props.onRun ?? s.onRun;
		s.showTime = props.showTime ?? s.showTime

		let onStart = props.onStart || s.onStart;
		s.onStart = e => {
			setRunning(true);
			onStart?.();
		}

		let onStop = props.onStop || s.onStop;
		s.onStop = e => {
			setRunning(false);
			onStop?.();
		}
		return s;
	})

	const [running, setRunning] = useState(setup.autoStart);


	return <div className='ui2-ui-counter' id={props.id} style={props.style}>
		{setup.label && <Label>{setup.label}</Label>}
		<Switch selected={running} onChange={e => {
			e? setup.start() : setup.stop();
		}} />
		<Counter setup={setup} />
		<Button round label='run now' onClick={e => {
			if (setup.isRunning) setup.reset();
			setup.onRun?.() || setup.onComplete?.();
		}} />
	</div>
}


//----------------------------------------------------------------------------- Counter
export const Counter = props => {
	const [setup] = useState(e => {
		let s = props.setup || {};
		s.value = 0;
		s.size = 36;
		s.stroke = 3;
		s.increase = false;		//false = decrease
		s.loop = props.loop ?? s.loop ?? true;
		s.count = props.count || s.count || 100;
		s.onComplete = props.onComplete || s.onComplete || null;
		s.onUpdate = props.onUpdate || s.onUpdate;
		s.onStart = props.onStart || s.onStart;
		s.onStop = props.onStop || s.onStop;
		s.autoStart = props.autoStart ?? s.autoStart ?? true;
		s.showTime = props.showTime ?? s.showTime ?? false;

		s.isRunning = false;
		s.isPaused = false;

		s.start = e => {
			if (s.isRunning || s.sount <= 0) return;
			s.isRunning = true;
			s.isPaused = false;
			s.value = s.count;
			setValue(s.count);
			setPaused(false);
			s.interval = setTimer(s.update); //setInterval(s.update, 1000);
			s.onStart?.();
		}

		s.stop = e => {		//goto 0
			if (!s.isRunning) return;
			s.isRunning = false;
			s.isPaused = false;
			// clearInterval(s.interval);
			clearTimer(s.interval);
			s.value = 0;
			setValue(s.value);
			s.onStop?.();
		}

		s.update = e => {
			s.value --;
			if (s.value <= 0){
				s.onComplete?.();
				if (s.loop){
					s.value = s.count;
				}else{
					// clearInterval(s.interval);
					clearTimer(s.interval);
					s.isRunning = false;
				}
			}else{
				s.onUpdate?.(s.value);
			}
			setValue(s.value);
		}
	
		s.pause = e => {
			if (s.isPaused) return;
			s.isPaused = true;
			// clearInterval(s.interval);
			clearTimer(s.interval);
			setPaused(true);
		}
	
		s.resume = e => {
			if (!s.isPaused) return;
			s.isPaused = false;
			s.interval = setTimer(s.update); //setInterval(s.update, 1000);
			setPaused(false);
		}
	
		s.reset = e => {
			s.value = s.count;
			setValue(s.value);
		}
	
		if (typeof props.setup === 'function') props.setup(s);
		return s
	})
	const [value, setValue] = useState(props.value || 0);
	const [paused, setPaused] = useState(false);


	useEffect(() => {
		setup.autoStart && setup.start();
		// setup.start();

		return e => {
			// clearInterval(setup.interval);
			clearTimer(setup.interval);
		}
	}, [])


	let st = setup.stroke;
	let s = setup.size;
	let s2 = setup.size / 2;
	let t = setup.showTime? getTimeString(value) : null;

	return (
		<div className={'ui2-counter' + (paused? ' paused' : '')}
			title='click to pause'
			onClick={e => setup.isRunning && (setup.isPaused? setup.resume() : setup.pause())}
			onDoubleClick={e => setup.isRunning && setup.reset()}
			style={{width:s+'px', height:s+'px'}}
			>
			<svg className='ui2-svg-spinner' width={s} height={s}>
				<circle			//ground-circle
					cx={s2} cy={s2} r={s2-st}
					// stroke='#fff' opacity={0.10}
					strokeWidth={st} fill='none'
					>
				</circle>
				<circle			//spinner-circle
					cx={s2} cy={s2} r={s2-st}
					// stroke='#fff' opacity={0.5}
					strokeWidth={st} fill='none'
					transform='rotate(-90)'
					transform-origin='center'
					// https://codepen.io/evth/pen/zBNqrL
					strokeDasharray={3.1416 * (s - 2 * st)}
					strokeDashoffset={3.1416 * (s - 2 * st)
						* ((setup.increase? 0 : 1) + value / setup.count)}
					// style={{transition:'0.2s'}}
				>
				</circle>
			</svg>
			{/* <div className='ui2-counter-value'>{'23:45\n25'}</div> */}
			{/* <div className='ui2-counter-value'>{'84200'}</div> */}
			{setup.showTime ?
				<div className={'ui2-counter-value time' + (t.length > 5? ' l2' : '')}>{t}</div>
				:
				<div className={'ui2-counter-value' + (value >= 1000? ' small' : '')}>{value}</div>
			}
			</div>
	)
}
// ---------------------------------------------------------------------------- getTimeInSeconds
const getTimeString = sec => {
	let h = Math.floor( sec / 3600);
	let m = Math.floor((sec - (h * 3600)) / 60);
	let s = sec - (h * 3600) - (m * 60);
	return (h? h+':' : '')
		+ (m < 10? '0'+m : m)
		+ (h? '\n' : ':')
		+ (s < 10? '0'+s : s);
}

//----------------------------------------------------------------------------- Version
export const Version = props => {
	return (
		<div id={props.id} className='ui2-version'>{props.value || ('Version: ' + global.config.version)}</div>
	)
}


// ---------------------------------------------------------------------------- UIStatus
export const UIStatus = props => {
	// console.log('*** render', props);
	const [status, setStatus] = useState(props.status);

	useEffect(() => {
		setStatus(props.status);
	}, [props.status]);

	return (
		<div className='ui2-item'>
			{props.label && <Label>{props.label}</Label>}
			<div className={'ui2-status' + (status? ' on' : ' off')} />
		</div>
	)
}


//----------------------------------------------------------------------------- UIView
export const UIView = props => {
	// const [content, setContent] = useState([
	// 	{label:'Label-1', value:10},
	// 	{value:20},
	// 	{label:'Label only'},
	// 	{label:'Label-4 with very many inline-text', text:'text-value'},
	// 	{value:20},
	// 	{label:'Check-Value', check:true},
	// 	{label:'Check-Box', type:'check', selected:true},
	// 	{label:'Switch-Value', type:'switch', selected:true},
	// 	{label:'Boolean Value', value:true},
	// 	{label:'Array-List', value:[
	// 		'value-1',
	// 		123,
	// 		'xxxxx-1',
	// 		'xxxxx-2',
	// 		'xxxxx-3',
	// 	]},
	// 	{label:'Object-List', value:{
	// 		react: '1.0.1',
	// 		electron: '2.0.2',
	// 		node: '3.0.3',
	// 	}},
	// 	{title:'New Section'},
	// 	{label:'Section-Group', open:true, section:[
	// 		{label:'section-1a', value:10},
	// 		{label:'section-1b', value:10},
	// 		{label:'section-1c', value:10},
	// 	]},
	// 	{label:'Counter', type:'counter', count:30, onComplete:e => console.log('counter complete!')},
	// 	{label:'Link-Url', type:'link', url:'https://www.google.com/'},
	// 	{label:'Label-3'},
	// 	{label:'Label-1', value:10},
	// 	{label:'Label-3'},
	// ]);
	const [items, setItems] = useState();


	useEffect(() => {
		// if (content) parseContent(content);
	}, []);


	useEffect(() => {
		if (!props.content || props.content === undefined) return;

		parseContent(props.content);	//-> set items

	}, [props.content]);


	const parseContent = c => {
		let el = Array.isArray(c)?
		c.map((e, i) => getItem(null, e, i))
		: Object.keys(c).map((e, i) => getItem(e, c[e], i))
		setItems(el);
	}


	const getItem = (label, item, i) => {
		if (!item) return null;

		label = item.title || item.name || item.label || label || item.id;
		// console.log('---add item', label, item);

		if (item.title){
			return <div className='ui2-ui-title'>{item.title}</div>
		}

		if (item.section){
			return <div className={'ui2-ui-section' + (item.open? ' open' : '')} key={i} >
				<div className='ui2-ui-title'
					onClick={e => {
						item.open = !item.open;
						e.target.parentNode.className = 'ui2-ui-section' + (item.open? ' open' : '');
					}}
					>
					<div className='ui2-ui-section-symbol' />
					{label}
				</div>
				<div className='ui2-ui-group' >
					{Array.isArray(item.section)? item.section.map((e, j) => getItem(null, e, j))
					: Object.keys(item.section).map((el, j) => getItem(el, item.section[el], j))}
				</div>
			</div>
		}

		if (typeof item === 'string'){
			if (item.startsWith('http')) item = {label, type:'link', url:item};
		}
		
		let el = getElement(label, item);

		return <div className={'ui2-ui-row' + (props.noline? ' noline' : '')} key={i}>
			<div className='ui2-ui-label'>{label}</div>
			<div className='ui2-ui-item'>{el}</div>
		</div>
	}

	const getElement = (label, item, i) => {
		let el;
		let v = item.value ?? item.text ?? item.check ?? item;
		let type = item.type || Sys.getType(v);
// console.log('---getElement:', type, label, item);

		switch (type){
			case 'input': el = <InputItem key={i} value={item.value} onChange={item.onChange} />;
				break;

			case 'round-button':
			case 'button': el = <Button key={i} flex={item.flex} label={item.label}
					onClick={item.onClick}
					round={item.round || type === 'round-button'}
				/>; break;

			case 'buttonbar':
			case 'buttons': el = <ButtonBar key={i} flex={item.flex} content={item.content} onSelect={item.onSelect} />;
				break;

			case 'counter': el = <UICounter key={i} onComplete={item.onComplete} count={item.count} autoStart={item.autoStart} />;
				break;

			case 'link': el = <div key={i} className='type-l' onClick={e => {
					shell?.openExternal(item.url || item.value);
				}}>{item.url || item.value}</div>; break;

			case 'switch': el = <Switch key={i} selected={item.selected} />; break;

			case 'check':
			case 'boolean': el = <Checkbox key={i} selected={item.selected} label={item.label} />; break;

			case 'status': el = <UIStatus key={i} status={item.status} label={item.label} />; break;

			case 'string': el = <div key={i} className='type-s'>{v}</div>; break;

			case 'number': el = <div key={i} className='type-n'>{v}</div>; break;

			case 'array': el = <div key={i} className='type-a'>
					{v.map((e, j) => <div key={j}>{e}</div>)}
				</div>; break;

			default:
				if (item.content){
					if (item.content.$$typeof){		//custom element
						el = item.content

					}else if (Array.isArray(item.content)){
						return item.content.map((el, j) => getElement('', el, j))
					}

				}else if (type === 'object'){
					el = <div className='type-a'>
						{Object.keys(v).map((k, j) => <div key={j}>{k + ': ' + v[k]}</div>)}
					</div>

				}else{
					el = props.types?.[type];
				}
		}

		return el;
	}


	return (
		<div className='ui2-ui-view'  id={props.id} style={getStyles(props)}>
			{props.title &&
				<div className='ui2-ui-title'>{props.title}</div>
			}
			<div className='ui2-ui-container'>
				{items}
				{props.children}
			</div>
		</div>
	);
}


//----------------------------------------------------------------------------- UIInput
export const UIInput = props => {
	return (
		<div className='ui2-ui-row'>
			<div className='ui2-ui-label'>{props.label}</div>
			<div className='ui2-ui-item'>
				<InputItem value={props.value} onChange={props.onChange} />
			</div>
		</div>
	)
}


//----------------------------------------------------------------------------- UICheck
export const UICheck = props => {
	return (
		<div className='ui2-ui-row'>
			<div className='ui2-ui-label'>{props.label}</div>
			<div className='ui2-ui-item'>
				<Checkbox />
			</div>
		</div>
	)
}


//----------------------------------------------------------------------------- DebugView
// simple debug view
/*
setup sample:
{
	style:'left',
	buttons:[
		{label:'exit', onClick:e => Store.onExit()},
	]
}
*/
export const DebugView = props => {
	const [open, setOpen] = useState(props.open ?? false);
	const [data, setData] = useState(props.data || props.setup?.data);

	const [setup] = useState(e => {
		let s = props.setup || {};
		s.close = e => setOpen(false);
		s.open = e => setOpen(true);
		s.showData = e => setData(e);
		global.debug = s
		return s
	})

	const style = (props.left || setup.style === 'left')? {left:0, right:'auto'}
	: (props.right || setup.style === 'right')? {right:'auto', left:0}
	: null

	return (
		<>
		{open &&
			<HBox id='ui2-debug-view'>
				<Box width={100} className='ui2-debug-control'
					style={style}
					>
					{props.setup?.buttons &&
						<ButtonBar className={'ui2-debug-buttons'} content={props.setup.buttons}/>
					}
				</Box>
				<Box className={'ui2-debug-container'}>
					<div className='ui2-debug-header'>
						<div>{navigator.userAgent}</div>
					</div>
					{data && <JsonView2 sourceData={data} />}
				</Box>
			</HBox>
		}
		<div className='ui2-debug-close' style={style} onClick={e => setOpen(!open)}></div>
		</>
	)
}


//----------------------------------------------------------------------------- App
export const App = props => {
	return (
		<div className='ui2-app'>
			{props.children}
			{props.drawer && <Drawer>{props.drawer}</Drawer>}
			<Modal open={false} />
		</div>
	)
}


//----------------------------------------------------------------------------- Drawer
export const Drawer = props => {
	const [open, setOpen] = useState(props.open);

	return (
		<div className='ui2-drawer'>
			{props.children}
			<div></div>
		</div>
	)
}


//----------------------------------------------------------------------------- StatusBar
export const StatusBar = props => {
	const [state, setState] = useState('Status : ON');

	useEffect(() => {
		global.state = e => setState(e);
	}, [])

	return (
		<div className='ui2-status-bar'>{state}</div>
	)
}


//----------------------------------------------------------------------------- SearchBar
export const SearchBar = props => {
	const [value, setValue] = useState(props.value || '');

	return (
		<div className='ui2-search-bar' style={getStyles(props)}>
			{props.label &&
				<div className='ui2-search-label'>{props.label}</div>
			}
			<div className='ui2-search-box'>
				<input
					className='ui2-input'
					type='text'
					value={value}
					placeholder={props.placeholder}
					onChange={e => {
						setValue(e.target.value);
						props.onChange && props.onChange(e.target.value)}
					}
					onKeyDown={e => {
						if (e.key === 'Enter' && props.onSearch) props.onSearch(value)
					}}
				/>
				{/* <i className='material-icons' onClick={e => props.onSearch && props.onSearch(value)}>search</i> */}
				<div className='ui2-search-icon' onClick={e => props.onSearch && props.onSearch(value)}>
					{/* 🔍 */}
					<svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="-5 -5 60 60" fill="#FFFFFF">
						<path d="M39.8 41.95 26.65 28.8q-1.5 1.3-3.5 2.025-2 .725-4.25.725-5.4 0-9.15-3.75T6 18.75q0-5.3 3.75-9.05 3.75-3.75 9.1-3.75 5.3 0 9.025 3.75 3.725 3.75 3.725 9.05 0 2.15-.7 4.15-.7 2-2.1 3.75L42 39.75Zm-20.95-13.4q4.05 0 6.9-2.875Q28.6 22.8 28.6 18.75t-2.85-6.925Q22.9 8.95 18.85 8.95q-4.1 0-6.975 2.875T9 18.75q0 4.05 2.875 6.925t6.975 2.875Z"/>
					</svg>
				</div>
			</div>
			{/* <i className='material-icons' onClick={e => {
				setValue('');
				props.onSearch && props.onSearch('')
			}}>close</i> */}
			<div className='ui2-close' onClick={e => {
				setValue('');
				props.onSearch && props.onSearch('')
			}}>×</div>
		</div>
	)
}


//----------------------------------------------------------------------------- NumPad
export const NumPad = props => {
	const value = useRef('');

	const max = props.max || Infinity;
	const min = props.min || 0;
	const float = useRef(false);

	useEffect(() => {
		setTimeout(e => document.addEventListener('click', props.onClose), 0)

		return e => document.removeEventListener('click', props.onClose);
	}, []);

	const onClick = e => {
		e.nativeEvent.stopImmediatePropagation();

		let k = e.target.innerText;
		// if (k === '✖') return props.onClose? props.onClose() : null;
		if (k === '.'){
			if (float.current) return;		//already set
		}

		let v = value.current;
		if (v === '0') v = '';
		v = k === '⇦'? v.substring(0, v.length - 1) : v + k;
		if (v === '') v = '0';
		// v = String(Math.max( Math.min( Number(v), max ), min ));
		value.current = v;
		float.current = v.indexOf('.') > -1;

		if (props.onChange) props.onChange(v);
	}

	return (
		<div className={'ui2-numpad' + (props.className? ' ' + props.className : '')}>
			<div className='ui2-numpad-keys' onClick={onClick}>
				{/* {'123456789✖0.⇦'.split('').map((e, i) => <div key={i} className='ui2-numpad-key'>{e}</div>)} */}
				{'123456789.0⇦'.split('').map((e, i) => <div key={i} className='ui2-numpad-key'>{e}</div>)}
			</div>
			{/* <div className='ui2-numpad-buttons'>
				<Button flex label='OK' />
				<Button flex label='CANCEL' />
			</div> */}
		</div>
	)
}


//----------------------------------------------------------------------------- VideoPlayer
export const VideoPlayer = props => {
	const viewRef = useRef();
	const videoRef = useRef();
	const canvasRef = useRef();
	const [source, setSource] = useState();
	// const [duration, setDuration] = useState(0);
	const [context, setContext] = useState(false);
	// const [videoPlay, setVideoPlay] = useState(false);
	// const [, render] = useReducer(e => !e);

	const [setup] = useState(e => {
		let s = props.setup || {};
		s.viewRef = viewRef;
		s.videoRef = videoRef;
		s.preview = false;
		return s;
	})

	// useEffect(e => {
	// 	return (e => {})
	// }, [])

	useEffect(() => {
		if (props.src === undefined || props.src === source) return;

		// videoRef.current.currentTime = 3;
		// setup.videoRef.current.currentTime = 3;
		// console.log('set video:', props.src);
		setup.preview = false;
		setContext(false);
		setSource(props.src);
	}, [props.src])


	const onContext = e => {
		setContext(e => {
			if (!e && !setup.preview){
				setup.preview = true;
				createVideoMap(source, {canvas:canvasRef.current})
			}
			return !e;
		})
	}


	const onData = e => {
		console.log('---video meta data:', e.target.duration, e.target.videoWidth, e.target.videoHeight);
		// e.target.currentTime = 2;
		// setDuration(e.target.duration);
		setup.duration = e.target.duration;
		props.onLoad && props.onLoad();
	}


	return <div className='ui2-video' ref={viewRef} style={getStyles(props)} onContextMenu={onContext}>
		{/* <Slider interactive min={0} max={duration} steps={1000} onChange={e => {
			// console.log(e);
			// let v = videoRef.current;
			// v.currentTime = e * v.duration;
			videoRef.current.currentTime = e;
		}} /> */}

		<video className='ui2-video-frame'
			ref={videoRef}
			id={props.id}
			key={source}		//to update the video src!
			controls={props.controls}
			loop={props.loop}
			muted={props.muted}
			playsInline={true}
			webkit-playsinline={"true"}
			onSeeked={props.onSeeked}
			autoPlay={props.autoPlay}
			onPlay={props.onPlay}
			onLoadedMetadata={onData}
			onError={props.onError}
			>
			{/* <source src={e.src + '?playsinline=1'} type='video/mp4'/> */}
			<source src={source} type='video/mp4'/>
		</video>

		{/* <i className={'material-icons video-play' + (videoPlay? ' hidden' : '')}>play_circle_outline</i> */}

		<canvas ref={canvasRef} className='ui2-video-canvas'
			style={{visibility:context? 'visible' : 'hidden'}}
		/>

		{props.children}
	</div>

}


//----------------------------------------------------------------------------- Image
// full auto
// full fit
// fit, cover, src, alt
export const Image = props => {
	const [src, setSrc] = useState();
	const imgRef = useRef();

	const [loader] = useState(e => {
		let i = new ImageLoader({onLoad:e => {
			// console.log('---loaded!', e.image.width, e.image.height);
			setSrc(e.image.src);

		}, onError:e => {
			console.log('---error!', e.source);
		}});

		return i;
	})


	useEffect(() => {
		// console.log('---init')
	}, [])


	useEffect(() => {
		// console.log('---changed');
		loader.load(props.src);

	}, [props.src])	//src changed


	// const onLoad = e => {
	// 	// console.log(e.target.naturalWidth, e.target.width);
	// 	!!props.onLoad && props.onLoad(e);
	// }


	return (
		<div className={'ui2-image' + (props.className? ' ' + props.className : '')}
			id={props.id}
			// style={getStyles(props)}
			style={{
				width		: loader.width + 'px',
				height		: loader.height + 'px',
			}}
			onClick={props.onClick}
			>
			{src &&
				<img
					ref={imgRef}
					src={src} alt={props.alt || src}
					// onLoad={onLoad}
					style={{
						objectFit	: props.fit || props.cover? 'cover' : props.contain? 'contain' : null,
						// width		: loader.width + 'px',
						// height		: loader.height + 'px',
						// width		: props.auto? 'auto' : '100%',
						// height		: props.auto? 'auto' : '100%',
					}}
				/>
			}
		</div>
	)
}


//----------------------------------------------------------------------------- Log
export const Log = props => {
	// const logText = useRef('');

	useEffect(() => {

	}, [])

	return (
		<Modal open={true}>
			LOG
		</Modal>
	)
}



//----------------------------------------------------------------------------- Group
export const Group = props => {
	return (
		<div className='ui2-group' id={props.id} style={getStyles(props)}>
			{props.children}
		</div>
	)
}


//----------------------------------------------------------------------------- Backdrop
export const Backdrop = props => {
	return (
		<div id={props.id}
			className='ui2-backdrop'
			style={props.style}
			>
			{props.title}
			{props.spinner && <Spinner />}
			{props.children}
		</div>
	)
}


//----------------------------------------------------------------------------- Loading
export const Loading = props => {
	return (
		<div id={props.id}
			className='ui2-loading'
			style={props.style}
			>
			{props.title ?? 'LOADING ...'}
			{props.spinner && <Spinner />}
			{props.children}
		</div>
	)
}


//----------------------------------------------------------------------------- Spinner
export const Spinner = props => {
	return (
		<svg className={'ui2-spinner' + (props.className? ' ' + props.className : '')}
			id={props.id}
			style={{...props.style, transform:'scale(' + (props.scale || 1) + ')'}}
			>
			<circle cx='20' cy='20' r='16' stroke={props.color || 'white'} opacity={0.10}></circle>
			<circle cx='20' cy='20' r='16' stroke={props.color || 'white'} opacity={0.5}></circle>
		</svg>
	)
}


//----------------------------------------------------------------------------- Dummy
export const Dummy = props => {
	return (
		<div
			ref={props.forwardRef}
			className={'ui2-dummy' + (props.className? ' ' + props.className : '')}
			id={props.id}
			onClick={props.onClick}
			onMouseDown={props.onDown}
			style={getStyles(props)}
			>
			{props.children}
		</div>
	)
}


//----------------------------------------------------------------------------- Rating
export const Rating = props => {
	const [value, setValue] = useState(props.value);

	return (
		<div className={'ui2-rating' + (props.className? ' ' + props.className : '')} id={props.id}>
			{[...new Array(props.count || 4)].map((e, i) =>
				<div key={i} className={'ui2-rating-icon' + (i < value? ' filled' : '')}
					onClick={e => {
						e.stopPropagation();
						e.preventDefault();
						let v = i === 0 && value === 1? 0 : i + 1;
						setValue(v);
						if (props.onChange) props.onChange(v);
					}}
				/>
			)}
		</div>
	)
}


//----------------------------------------------------------------------------- Modal
export const Modal = props => {
	const [open, setOpen] = useState(props.open);

	useEffect(() => {
		setOpen(props.open);
	}, [props.open])

	return (
		<div className={'ui2-modal' + (open? ' open' : '')}
			// tabIndex={-1}
			// onKeyDown={e => {console.log('key:', e)}}
			// onClick={e => {
			// 	if (props.onClose) props.onClose();
			// 	setOpen(false);
			// }}
			>
			{props.children}
			{props.close &&
				<div className='ui2-modal-close' onClick={e => setOpen(false)}>✖</div>
			}
		</div>
	)
}


//----------------------------------------------------------------------------- openModal
// only one model instance allowed
var modalView
const modalEsc = e => {if (e.key === 'Escape') closeModal()}
 
export const openModal = (child, props) => {
	if (modalView) closeModal()

	modalView = document.createElement('div')
	document.body.appendChild(modalView);
	document.addEventListener('keydown', modalEsc, {once:true})

	ReactDOM.render(
		<Dialog open={true} close={true}
			// header={props?.header}
			// buttons={props?.buttons}
			{...props}
			onClose={e => {
				closeModal()
				props?.onClose?.()
			}}>
			{child}
		</Dialog>
		, modalView
	)
}


//----------------------------------------------------------------------------- closeModal
// remove the current modal
export const closeModal = e => {
	try{
		document.body.removeChild(modalView)
		document.removeEventListener('keydown', modalEsc, {once:true})
	}catch(e){}
	modalView = null
}


//----------------------------------------------------------------------------- Dialog
// props: open, header, close, footer, onClose, automount
//
export const Dialog = ({open, automount, header, close, onClose, footer, buttons, onSelect, children}) => {
	const [open_, setOpen] = useState();

	useEffect(() => setOpen(open), [open])

	if (!open_ && !automount) return null;

	return (
		<Modal open={open_}>
			{/* <div className='ui2-dialog-container'> */}
			<DragView className='ui2-dialog-container' includes={['ui2-dialog-header']}>
				{!!header &&
					<div className='ui2-dialog-header'>
						{header}
						{close !== false &&
							<div className='ui2-dialog-close' onClick={e => {
								onClose?.();
								setOpen(false)
							}
						}>✖</div>
						}
					</div>
				}
				{!!children &&
					<div className='ui2-dialog-body'>
						{children}
					</div>
				}
				{(footer || buttons) &&
					<div className='ui2-dialog-footer'>
						{footer}
						{!!buttons &&
							buttons.map(b => <Button key={b} label={b} onClick={onSelect} />)
						}
					</div>
				}
			</DragView>
		</Modal>
	)
}


//----------------------------------------------------------------------------- HSplit
export const HSplit = e => {
	return (
		<div className='ui2-split hsplit'>
			{e.children}
		</div>
	)
}


//----------------------------------------------------------------------------- VSplit
export const VSplit = e => {
	return (
		<div className='ui2-split vsplit'>
			{e.children}
		</div>
	)
}


//----------------------------------------------------------------------------- Box
/* props:
		width, height, minWidth, maxWidth, minHeight, maxHeight
		scroll
		closer, zoomer, divider
*/
export const Box = props => {
	const ref = useRef();

	return (
		<>
		<div
			ref={ref}
			style={{
				...getStyles(props),
				// width		: parseCSS(props.width),
				// height		: parseCSS(props.height),

				flexGrow	: (props.width || props.height)? 0 : 1,
				flexShrink	: (props.width || props.height)? 0 : 1,
				// width		: parseCSS(props.width) || '100%',
				// height		: parseCSS(props.height) || '100%',

				minWidth	: parseCSS(props.minWidth),
				maxWidth	: parseCSS(props.maxWidth),
				minHeight	: parseCSS(props.minHeight),
				maxHeight	: parseCSS(props.maxHeight),
				// padding		: parseCSS(props.padding),
			}}
			className={'ui2-box'
				+ (props.className? ' ' + props.className : '')
				+ (props.scroll? ' scroll' : '')}
			id={props.id}
			onClick={props.onClick}
			onWheel={props.onWheel}
			>
			{/* {props.ratio &&
				<style scoped>
				{'@media (min-aspect-ratio: 1/1) {#view {background: red;}}'}
				</style>
			} */}

			{props.children}

			{props.closer && <div className='ui2-box-control closer' onClick={e => {
				e.target.parentNode.classList.toggle('closed');
			}} />}

			{props.zoomer && <div className='ui2-box-control zoomer' onClick={e => {
				Sys.switchFullscreen(e.target.parentNode);
			}} />}
		</div>
		
		{props.divider && <Divider client={ref} /> }
		</>
	)
}



//----------------------------------------------------------------------------- ABox
export const ABox = props => {
	return (
		<div className='ui2-abox' id={props.id}>{props.children}</div>
	)
}



//----------------------------------------------------------------------------- HBox
export const HBox = props => {
	return (
		<Box
			className={'hbox' + (props.className? ' ' + props.className : '')}
			{...props}
			>
			{props.children}
		</Box>
	)
}



//----------------------------------------------------------------------------- VBox
export const VBox = props => {
	return (
		<Box
			className={'vbox' + (props.className? ' ' + props.className : '')}
			{...props}
		/>
	)
}



//----------------------------------------------------------------------------- UILabel
export const Label = props => <div className='ui2-label'>{
		props.label || props.children
	}</div>




//============================================================================= ListView Component
export const ListView = memo(props => {
	const [source, setSource] = useState(props.source);
	const [selectedIndex, setSelectedIndex] = useState(-1);
	const lastIndex = useRef(-1);

	const ItemRenderer = props.itemRenderer || ListItem		//ListItem


	useEffect(() => {
		let src = props.source;
		if (src === undefined) return;

		if (!Array.isArray(src) && typeof src === 'object') src = Object.keys(src).map(e => {
			src[e].label = e
			return src[e]
		})
		setSource(src);

		let i = props.selectedIndex;
		if (i === undefined || i === lastIndex.current) return;
		if (src[i]){
			onSelect(i, src[i], false);		//-> setSelectedIndex
		}else{
			lastIndex.current = -1;
			setSelectedIndex(-1);
		}
	}, [props.source, props.selectedIndex]);

	
	useEffect(() => {
		if (props.cache && source){
			let i = Number(localStorage.getItem(props.cache));
			if (i >= 0) onSelect(i, source[i], true);
		}
	}, [])


	const onSelect = (i, e, clicked=true) => {	//static method
		if (i === null || i === undefined) i = -1;
		if (lastIndex.current === i) return;			//same as selected

		lastIndex.current = i;
		setSelectedIndex(i);
		if (props.cache) localStorage.setItem(props.cache, i);

		if (i > -1 && clicked && props.onSelect) props.onSelect(i, e);
		if (props.onChange) props.onChange(i, e);
	}


	const onKeyEvent = e => {
		switch (e.key){
			case 'ArrowDown':
			case 'ArrowRight':
				if (selectedIndex + 1 < source.length){
					onSelect(selectedIndex + 1, source[selectedIndex + 1])
				}
				break
			case 'ArrowUp':
			case 'ArrowLeft':
				if (selectedIndex > 0){
					onSelect(selectedIndex - 1, source[selectedIndex - 1])
				}
				break;
			default:
		}
	}


	return (
		<div className={'ui2-list-view' + (props.className? ' ' + props.className : '')}
			id={props.id}
			style={getStyles(props)}
			onKeyDown={onKeyEvent}
			tabIndex={0}
			>
			{props.header &&
				// <div className='ui2-list-view-header'>{<props.header />}</div>
				// <div className='ui2-list-view-header'>{props.header}</div>
				<div className={props.headerClass || 'ui2-ui-title'}>{props.header}</div>
			}
			<div className='ui2-list-view-container'>
				{source && source.map((e, i) => 
					<ItemRenderer
						key={i}
						id={i}
						className='ui2-list-view-item'
						data={e}
						selected={i === selectedIndex}
						onClick={onSelect}
					/>
				)}
			</div>
		</div>
	)
});


//----------------------------------------------------------------------------- ListItem
export const ListItem = memo(props => {
	return (
		<div
			// ref={r => props.data._ref = r}		//put item reference to item data
			className={props.className + (props.selected? ' selected' : '')}
			id={props.id}
			onClick={e => props.onClick(props.id, props.data)}
		>{props.data.label || props.data.name || props.data.id || props.data}</div>
	)
});


//----------------------------------------------------------------------------- Icon
export const Icon = props => {
	return <div className={'ui2-icon' + (props.className? ' ' + props.className : '')}
			onClick={props.onClick}
			style={getStyles(props)}
		>
		{props.icon && <i className='material-icons'>{props.icon}</i>}
		{props.image && <img src={props.image} alt='' />}
		{props.children}
	</div>
}


//----------------------------------------------------------------------------- IconButton
export const IconButton = props => {
	return <div className={'ui2-icon-button' + (props.className? ' ' + props.className : '')}
			id={props.id}
			onClick={props.onClick}
			style={getStyles(props)}
		>
		{props.icon && <i className='material-icons'>{props.icon}</i>}
		{props.label && <span>{props.label}</span>}
		{props.image && <img src={props.image} alt='' />}
		{props.children}
	</div>
}



//----------------------------------------------------------------------------- UIButton
export const Button = props => {
	// console.log('set', props.value);
	const [selected, setSelected] = useState(props.selected);
	const isToggle = props.toggle !== undefined? props.toggle : Array.isArray(props.label)? true : false;
	// console.log('---render', isToggle, props);

	const onClick = e => {
		if (isToggle || props.check) setSelected(!selected);
		if (props.onClick) props.onClick(e);
		if (props.onChange) props.onChange(!selected);
	}

	useEffect(() => {
		if (selected === props.selected) return;
		// console.log('???---change button from', selected, 'to', props.selected);
		setSelected(props.selected);
		// if (props.onChange) props.onChange(selected);
	}, [props.selected]);

	let label = Array.isArray(props.label)? props.label[selected? 1 : 0] : props.label || '';


	return <div
		id={props.id}
		className={'ui2-button'
			+ (props.className? ' ' + props.className : '')
			+ (props.check? ' check' : '')
			+ (props.round? ' round' : '')
			+ (isToggle? ' toggle' : '')
			+ (selected && !props.check && props.toggleSelect !== false? ' selected' : '')
		}
		style={getStyles(props)}
		onClick={e => {
			e.preventDefault();
			e.stopPropagation();
			onClick(label)
		}}
		title={props.title}
		>

		{props.icon &&
			<i className='material-icons ui2-button-icon'>{props.icon}</i>
		}
		{label &&
			<span>{label}</span>
		}
		{props.check &&
			<div className={'ui2-checkbox' + (selected? ' selected' : '')} />	//&nbsp;</div>	//&nbsp; needs for flex align!
		}
		{props.image &&
			<img className='ui2-button-image' src={props.image} alt='' />
		}
	</div>
}

// {/* <div className={'ui2-check-button' + (selected? ' checked' : '')}>
// 	{selected && <i className='material-icons'>done</i>}
// </div> */}


//----------------------------------------------------------------------------- UIButton
export const ButtonBar = props => {
	const [selected, setSelected] = useState(props.value);
	const style = props.cols? {flexBasis:'calc(100%/' + props.cols + ')'} : null;


	const onClick = (i, el, e) => {
		if (props.toggle && i === selected){	//unselect last selected
			if (props.allowMulti){
				props.onSelect?.(i, props.content[i], e);	//same clicked again
				e?.onClick?.(el);	//single button click handler
				return
			}
			if (!props.allowNull) return		//don't unselect if not allowNull
			i = -1
			el = null
		}

		setSelected(i);

		// props.onSelect?.(i, props.content[i], e);
		props.onSelect?.(i, el, e);

		e?.onClick?.(el);	//single button click handler
	}


	useEffect(() => {		//update if selection changed
		props.onChange?.(selected);
	}, [selected]);


	useEffect(() => {		//updated props value from outside
		setSelected(props.value);
	}, [props.value]);


	return <div
		id={props.id}
		className={'ui2-button-bar' + (props.className? ' ' + props.className : '')}
		// style={props.style}
		style={getStyles({flex:'0 0 auto', ...props})}
		>
		{props.content?.map((e, i) => e &&
			<Button key={i}
				flex={props.flex}
				style={{...style, ...e.style}}
				label={e.name || e.label || e.props?.label || e.id || e}
				selected={(props.toggle && i === selected && !props.multiselect)
					|| e.selected}
				title={props.title}
				// icon={e.icon}
				// image={e.image}
				// toggle={e.toggle || props.toggle || e.selected !== undefined || Array.isArray(e.label) || Array.isArray(e)}
				check={e.check || e.selected !== undefined}
				{...e}	//replace all singele atributes
				// toggle={props.toggle || props.multiselect}
				onClick={el => onClick(i, el, e)}
			/>
		)}
	</div>
}


// ---------------------------------------------------------------------------- Checkbox
export const Checkbox = props => {
	// console.log('*** render', props);
	const [selected, setSelected] = useState(props.selected);

	const onClick = e => {		//changed inside
		e.preventDefault();
		e.stopPropagation();
		setSelected(!selected);
		props.onChange && props.onChange(!selected);
	}

	useEffect(() => {			//changed from outside
		setSelected(props.selected);
	}, [props.selected]);

	return (
		<div className='ui2-item' onClick={onClick} style={props.style}>
			{props.label && <Label>{props.label}</Label>}
			<div className={'ui2-checkbox'
				+ (selected? ' selected' : '')
				+ (props.dot? ' dot' : '')
			} />
		</div>
	)
}


// ---------------------------------------------------------------------------- Switch
export const Switch = props => {
	const [selected, setSelected] = useState(props.selected);

	const onClick = e => {		//changed inside
		setSelected(!selected);
		props.onChange?.(!selected);
	}

	useEffect(() => {			//changed from outside
		// console.log('*** changed!');
		setSelected(props.selected);
	}, [props.selected]);

	return (
		<div className='ui2-item' onClick={onClick}>
			{props.label && <Label>{props.label}</Label>}
			<div className={'ui2-switch' + (selected? ' selected' : '')}>
				<div className='ui2-switch-label on'>on</div>
				<div className='ui2-switch-label off'>off</div>
			</div>
		</div>
	)
}


/*
// ---------------------------------------------------------------------------- Checkbox
const Checkbox_ = props => {
	const [value, setValue] = useState(props.value !== undefined? props.value : false);

	const onClick = e => {
		setValue(!value);
		if (props.onChange) props.onChange(!value);
	}

	useEffect(() => {
		if (props.value === undefined || props.value === value) return;
		// console.log('!has changed! from', value, 'to', props.value);
		setValue(props.value);
	}, [props.value]);

	// console.log('---checkbox render', value, props.value);
	return (
		<div className='ui2-check'
			style={props.style} onClick={onClick}
			>
			<div className={'ui2-check-button' + (value? ' checked' : '')}>
				{value && <i className='material-icons'>done</i>}
			</div>
			<div className='ui2-check-label'>{props.label}</div>
		</div>
	)
}
*/

/*
// ---------------------------------------------------------------------------- Checkbox
const Checkbox = e => <div className='ui2-check'
	style={e.style} onClick={() => e.onChange(!e.value)} >
	<div className={'ui2-check-button' + (e.value? ' checked' : '')}>
		{e.value && <i className='material-icons'>done</i>}
	</div>
	<div className='ui2-check-label'>{e.label}</div>
</div>
*/

/*
// ---------------------------------------------------------------------------- DateTime
export const DateTime = e => {
	const [time, setTime] = useState(moment().format('DD.MM.YYYY HH:mm:ss'));

	useEffect(() => {
		if (e.autoUpdate !== false){
			let timer = global.onTimer(e => {
				setTime(moment().format('DD.MM.YYYY HH:mm:ss'));
			})
			return () => global.clearTimer(timer);		//cleanup
		}
	}, []);

	return <div>{time}</div>
}
*/

/*
// ---------------------------------------------------------------------------- MultiItem
const MultiItem = e => <div className='ui2-multi'>
	{e.value.map((e, i) => <div key={i} className='ui2-multi-item'>{e}</div>)}
</div>
*/


// ---------------------------------------------------------------------------- ValueItem
export const ValueItem = e => <div className='ui2-value' style={e.style} >
	{e.label && <div className='ui2-inline-label'>{e.label}</div>}
	{typeof e.value === 'function'? e.value() : e.value}
</div>



// ---------------------------------------------------------------------------- LabelItem
export const LabelItem = e => <div className='ui2-inline-value' style={e.style} >
	{e.label && <span className='ui2-inline-label'>{e.label}</span>}
	{e.value}
</div>



// ---------------------------------------------------------------------------- PlayTime
export const PlayTime = e => {
	let count = 0;

	const timeFormat = c => {
		count = c;
		let h = Math.floor( count / 3600);
		let m = Math.floor((count - (h * 3600)) / 60);
		let s = count - (h * 3600) - (m * 60);
		return h + ':' + (m < 10? '0'+m : m) + ':' + (s < 10? '0'+s : s);
	}

	const [time, setTime] = useState(timeFormat(0));

	useEffect(() => {
		let timer = global.onTimer(e => setTime(timeFormat(count + 1)))
		return () => global.clearTimer(timer);		//cleanup
	}, []);

	return <div>{time}</div>
}



// ---------------------------------------------------------------------------- Countdown
export const Countdown = props => {
	let count = props.value || 0;
	// console.log('###', count);
	const [time, setTime] = useState(count);

	useEffect(() => {
		if (!count) return;

		let timer = global.onTimer(e => {
			setTime(--count);
			if (props.onTime) props.onTime(count);
			if (count === 0){
				global.clearTimer(timer);
				if (props.onComplete) props.onComplete();
			}
			// if (props.onChange) props.onChange(props, count, false);
		});
		if (props._ref) props._ref = timer;			//reference to the timer

		return () => global.clearTimer(timer);		//cleanup
	}, []);

	return <div>{time} sec.</div>
}


// ---------------------------------------------------------------------------- Progress
// type: percent, steps, range
export const Progress = e => {
	let max = e.max || 1;
	let value = e.value === undefined? 0 :
		e.value < 0? 0 : e.value > max? max : e.value;
	let percent = 100 * value / max;
	let label = e.mode === 'steps'?
		value + '/' + max:
		e.mode === 'range'?
		[value, max-value]:
		percent.toFixed(1) + '%';

	return <div className='ui2-progress'>
		<div className='ui2-progress-back' />
		<div className='ui2-progress-bar' style={{width: (percent)+'%'}} />

		{e.mode === 'range'?
			<div className='ui2-progress-value'>
				<div style={{width: (percent)+'%'}}>{label[0]}</div>
				<div style={{width: (100-percent)+'%'}}>{label[1]}</div>
			</div>
			:
			<div className='ui2-progress-value' style={{width: (percent)+'%'}}>{label}</div>
		}
	</div>
}


// ---------------------------------------------------------------------------- InputItem
export const InputItem = props => {
	const [value, setValue] = useState(props.value || '');

	useEffect(() => setValue(props.value || ''), [props.value])
	
	return (
		<input className={'ui2-input' + (props.className? ' ' + props.className : '')}
			type='text'
			value={value}
			placeholder={props.placeholder}
			onChange={e => {
				setValue(e.target.value);
				props.onChange && props.onChange(e.target.value)
			}}
			style={getStyles(props)}
		/>
	)
}


//----------------------------------------------------------------------------- InputSelect
// TODO
export const InputSelect = props => {
	const [value, setValue] = useState(props.value || '');
	const ref = useRef()

	const onChange = e => {
		setValue(e);
		props.onChange?.(e)
	}

	return (
		<>
			<input className='ui2-input'
				ref={ref}
				type='text'
				onKeyDown={e => {if (e.key === 'Escape') onChange('')}}
				value={value}
				onChange={n => onChange(n.target.value)}
				style={props.clear? {
					paddingRight : '25px',
					marginRight : '-20px',
				} : null}
			>
			</input>

			{props.clear && <div className='ui2-clear' onClick={e => {
				onChange('')
				ref.current.focus()
			}}>✕</div>} {/* ✖ */}
		</>
	)
}


// ---------------------------------------------------------------------------- InputAction
// <InputAction action='search' onAction={(value, action) => {
//		console.log(value, action)
// }}/>
//
export const InputAction = props => {
	const [value, setValue] = useState('');
	const actions = Array.isArray(props.action)? props.action : [props.action];

	const onChange = e => {
		setValue(typeof e === 'string'? e :e.target.value);
		props.onChange && props.onChange(e.target.value)
	}

	return (
		<div className='ui2-item'>
			<input className='ui2-input clear'
				type='text'
				value={value}
				onChange={onChange}
				onKeyDown={e => {		//enter key handler
					if (e.key === 'Enter') props.onAction(value, props.enter || actions[0]);
					if (e.key === 'Escape') onChange('')
				}}
			/>
			{/* <div className='ui2-clear'>✕</div> */}
			{actions.map((a, i) =>
				<Button key={i} label={a} onClick={e => props.onAction?.(value, a)} />
			)}
		</div>
	)
}


// ---------------------------------------------------------------------------- DropDown
// samples:
// <DropDown value={0} content={['Item-1', 'Item-2']} onChange={props.onChange} />
// <DropDown content={['Item-1', 'Item-2']} open />
//
export const DropDown = props => {
	// const [content, setContent] = useState(props.content || props.children);
	// const [value, setValue] = useState(props.value || 0);
	const [content, setContent] = useState();
	const [value, setValue] = useState();
	const [isOpen, setOpen] = useState(props.open || false);
	const [insert, setInsert] = useState(false)
	const [insertValue, setInsertValue] = useState('')


	useEffect(e => {
		if (isOpen){
			setTimeout(e => {
				document.addEventListener('click', e => setOpen(false), {once:true});	//once event
			}, 0)
		}
	}, [isOpen])


	useEffect(e => {
		setContent(props.content);
	}, [props.content])


	useEffect(e => {
		setValue(props.value || 0);
	}, [props.value])

	
	const onSelect = (e, i) => {
		e.preventDefault();
		if (i === value) return;
		setValue(i);
		if (props.onChange) props.onChange(i, props.content[i]);
	}


	const onInsert = () => {
		props.content.push(insertValue)
		setInsertValue('')
		setInsert(false)
		setValue(props.content.length-1)
	}


	return <div className='ui2-dropdown'
		style={getStyles(props)}
		>
		{insert?
			<>
				<input
					className='ui2-input'
					type='text'
					autoFocus
					value={insertValue}
					onChange={e => {
						setInsertValue(e.target.value);
					}}
					onKeyDown={e => {
						if (e.key === 'Enter') onInsert()
					}}
				/>
				<div className='ui2-dropdown-insert' onClick={onInsert} />
				<div className='ui2-dropdown-cancel' onClick={e => {
					setInsertValue('')
					setInsert(false)
				}}>✖</div>
			</>
			:
			<div className='ui2-dropdown-button'
				onClick={e => {
					e.preventDefault();
					setOpen(!isOpen)
				}}
				title={content?.[value]}
				>
				<span className='ui2-dropdown-label'>{content?.[value]}</span>
				{props.onAdd &&
					<span className='ui2-dropdown-add'
						onClick={e => {
							e.preventDefault();
							e.stopPropagation();
							setOpen(false)
							setInsert(true)
						}}
						title={props.addTitle || 'add element'}
					>＋</span>
				}
			</div>
		}
		<div className={'ui2-dropdown-content' + (isOpen? ' open' : '')}>
			{content?.map((el, i) =>
				<div key={i}
					className={'ui2-dropdown-item' + (i === value? ' selected' : '')}
					onClick={e => onSelect(e, i)}
				>
				<span className='ui2-dropdown-label'>{el}</span>
				{props.onRemove &&
					<span className='ui2-dropdown-remove'
						onClick={e => {
							e.preventDefault();
							e.stopPropagation();
							let content = [...props.content]
							content.splice(i, 1)
							setContent(content);
							setValue(0)
						}}
						title={props.removeTitle || 'remove element'}
					>✖</span>
				}
				</div>
			)}
		</div>
	</div>
}



//----------------------------------------------------------------------------- Select
/*
types: folder | file | option | input
*/
export const Select = props => {
	return (
		<div>SELECT</div>
	)
}



//----------------------------------------------------------------------------- OptionGroup
export const OptionGroup = props => {
	const [selected, setSelected] = useState(props.value);

	const onClick = (i, e) => {
		setSelected(i);
		if (props.onSelect) props.onSelect(i, e);
	}

	useEffect(() => {
		if (props.onChange) props.onChange(selected);
	}, [selected]);

	return <div className='ui2-option-group'>
		{props.content && props.content.map((e, i) =>
			<div key={i}
				className={'ui2-option' + (i === selected? ' selected' : '')}
				flex={props.flex}
				label={e}
				onClick={el => onClick(i, el)}
			>
				<div className='ui2-option-button' />
				<div className='ui2-option-label'>{e}</div>
			</div>
		)}
	</div>
}


//============================================================================= TabView
// use prop automount=true for preloading
// use prop autounmount=true for auto unmount if unselect
// TODO: dynamic update childs
//
export const TabView = (props) => {
	const [selectedIndex, setSelectedIndex] =
		useState(props.selectedIndex !== undefined? props.selectedIndex
		: props.cache? Number(localStorage.getItem(props.cache)) : props.selectedIndex || 0);

	const childs = props.children?
		Array.isArray(props.children)?
			props.children
			: [props.children]
		: props.content || props.source || [];
	// const childs = useMemo(() => props.children ?
	// 	Array.isArray(props.children)? props.children : [props.children]
	// 	: props.content || []
	// , [])

	const labels = props.labels || childs.map(e => (e?.props?.label || e?.props?.name || e?.props?.id) || 'unknown');


	useEffect(() => {
		console.error('Deprecated! use the lib3.TabView')
		
		let i = props.selectedIndex;
		if (i === undefined || i === selectedIndex) return;
		onSelect(i);

	}, [props.selectedIndex])


	const onSelect = e => {
		if (e === selectedIndex) return;

		// console.log('tab-view select', e);
		setSelectedIndex(e);
		if (props.cache) localStorage.setItem(props.cache, e);
		if (props.onSelect) props.onSelect(e);
	}


	return (
		<div className={'ui2-tabview' + (props.className? ' '+props.className : '')}
			id={props.id}
			style={getStyles(props)}
			>
			<ButtonBar
				value={selectedIndex}
				toggle
				content={labels}
				onSelect={onSelect}
			/>

			<PageView
				selectedIndex={selectedIndex}
				automount={props.automount}
				autounmount={props.autounmount}
				noscroll={props.noscroll}
			>{childs}</PageView>
		</div>
	)
}



//============================================================================= ScaleView
// const scaleViewSetup = {
// 	"width"		: 1080,
// 	"height"	: 1920,
// 	"enabled"	: true,
// }

export const ScaleView = props => {
	const setup = useRef();
	const [state, setState] = useState({scale:1, width:'100%', height:'100%', _width:'100%', _height:'100%'});
	const viewRef = useRef();

	
	useEffect(() => {
		let view = viewRef.current.parentNode;
		let ro = new ResizeObserver(e => {		//not working well when switching fullscreen
			onResize()
		});
		ro.observe(view);

		return () => {
			ro.unobserve(view);
		}
	}, [])


	useEffect(() => {
		if (props.setup === undefined) return;
		
		setup.current = props.setup;
		let view = viewRef.current.parentNode;

		if (setup.current && view) onResize();
		else setState({scale:1, width:'100%', height:'100%', _width:'100%', _height:'100%'})

	}, [props.setup])


	const onResize = () => {
		let sc = setup.current;
		if (!sc) return;

		let view = viewRef.current.parentNode;

		if (!view) return;

		let p = sc.padding || 0;
		let w = view.clientWidth - 2 * p;
		let h = view.clientHeight - 2 * p;

// console.log('---resize', w, h);

		let r0 = sc.orientationSwitch || 1;
		let r = w / h;
		let s, w0, h0;
		let d = r > r0? sc.landscape || sc : sc.portrait || sc;

		let wmin = d.minWidth || d.width || w;
		let wmax = d.maxWidth || d.width || w;
		let hmin = d.minHeight || d.height || h;
		let hmax = d.maxHeight || d.height || h;

		let rmax = wmax / hmin;
		let rmin = wmin / hmax;

		if (r > rmax){	//landscape
			w0 = wmax;
			h0 = hmin;
			// s = p.fitWidth === 'cover'? h / h0 : w / w0;
			s = h / h0;

		}else if (r < rmin){	//portrait
			w0 = wmin;
			h0 = hmax;
			s = w / w0;
		}else{
			w0 = wmin + (rmax !== rmin? (r - rmin) / (rmax - rmin) : 1) * (wmax - wmin);
			h0 = w0 / r;
			s = w / w0;
		}

		if (!sc.enabled){
			setState({scale:1, width:w0+'px', height:h0+'px', _width:'100%', _height:'100%'});

		// }else if (s !== state.scale){
		}else{
			// console.log('---scaledView scaling:', s, 'original:', w0, h0, 'scaled:', w0 * s, h0 * s);
			setState({scale:s, width:w0+'px', height:h0+'px', _width:(s*w0)+'px', _height:(s*h0)+'px'});
			props.onResize?.(w0, h0, s);
		}
		// if (s !== state.scale || w0 !== state.width || h0 !== state.height){
		}


	return (
		<div ref={viewRef} className='ui2-unscaled-view' id={props.id} onClick={props.onClick}
			style={{
				width : state._width,
				height : state._height,
				margin: 'auto',
				...props.style
			}}>
			{
				<div className='ui2-scaled-view'
					style={{
						width: state.width,
						height: state.height,
						transform : 'scale(' + state.scale + ')',
						transformOrigin : '0 0',
						position : 'relative',
						...props.style
					}}>
					{props.children}
				</div>
			}
		</div>
	)
}


//============================================================================= Slider Component
export const Slider = props => {
	const [, render] = useReducer(e => !e);
	const sliderRef = useRef();

	
	const setValue = value => {
		setup.value = Math.min( Math.max(setup.min, value), setup.max );
		update();
	}


	const [setup] = useState(e => {
		let min = props.min || 0;
		let max = props.max || 100;
		let value = props.value || 0;
		value = Math.min( Math.max(min, value), max );
		let step = props.step || (max - min) / (props.steps || 100);
		let digits = !!props.digits? props.digits : step < 1? step < 0.1? step < 0.01? 3 : 2 : 1 : 0;

		let s = {min, max, value, pos:0, percent:0, step, digits,
			interactive:props.interactive || false,
			setValue
		};
		if (typeof props.setup === 'function') props.setup(s);
		return s;
	})


	useEffect(() => {
		let control = new PointerControl(sliderRef.current, {
			onDown	: e => update(e.pos),
			onDrag	: e => update(e.pos),
			onUp	: e => {if (!setup.interactive && props.onChange) props.onChange(setup.value)}
		})
		update();

		return (e => {
			control.clearEvents();
			control = null;
		})
	}, [])


	useEffect(() => {
		let min = props.min !== undefined? props.min : setup.min;
		let max = props.max !== undefined? props.max : setup.max;
		let value = props.value !== undefined? props.value : setup.value;

		if (min !== setup.min || max !== setup.max || value !== setup.value){
			setup.min = min;
			setup.max = max;
			if (max - min <= 0) return;

			setup.step = props.step || ((max - min) / (props.steps || 100));
			setup.digits = !!props.digits? props.digits : setup.step < 1? setup.step < 0.1? setup.step < 0.01? 3 : 2 : 1 : 0;
			
			setValue(value);
		}

	}, [props.min, props.max, props.value])


	const update = p => {
		let s = setup;
		let w = sliderRef.current.clientWidth;
		let r = s.max - s.min;
		let x, v;

		if (p){		//update from slider event
			x = p.x < 0? 0 : p.x > w? w : p.x;
			v = Math.round((x * r) / (w * s.step)) * s.step;

		}else{		//update from outside
			v = Math.round(s.value / s.step) * s.step - s.min;
		}

		x = v * w / r;
		let value = Number((s.min + v).toFixed(s.digits));
		if (p && value === s.value) return;		//not changed

		s.pos = x;
		s.percent = 100 * x / w;
		s.value = value;

		if (p && s.interactive && props.onChange) props.onChange(value);

		render();
	}


	const onWheel = e => {
		// e.preventDefault();
		e.stopPropagation();

		setValue(setup.value + setup.step * (e.deltaY > 0? -1 : 1))
		props.onChange?.(setup.value);
	}


	return <div className='ui2-item'>
		{props.label && <Label>{props.label}</Label>}
		<div ref={sliderRef} className='ui2-slider' onWheel={onWheel}
			style={getStyles(props)}
			>
			<div className='ui2-slider-back' />
			<div className='ui2-slider-track' style={{width:setup.percent+'%'}} />
			{props.showLimits &&
				<>
				<div className='ui2-slider-min'>{setup.min}</div>
				<div className='ui2-slider-max'>{setup.max}</div>
				</>
			}
			<div className='ui2-slider-value' >{setup.value}</div>
		</div>
	</div>
}


// ---------------------------------------------------------------------------- SwitchLabel
export const SwitchLabel = props => {
	const [value, setValue] = useState();
	const [animationValue, setAnimationValue] = useState('initial');

	useEffect(() => {
		if (props.value === value) return;

		setTimeout( () => setAnimationValue('goUp'), 0 );
		setTimeout( () => {
			setValue(props.value)
			setAnimationValue('waitDown')
		}, 100 );
		setTimeout( () => setAnimationValue('initial'), 200 );

	}, [props.value])

	return (
		<div id={props.id}
			className={'switch-label' + (props.className? ' ' + props.className : '')}
			onClick={props.onClick}>
			<span className={animationValue}>{value}</span>
		</div>
	);
}


// ---------------------------------------------------------------------------- LikeCounter
// https://erikmartinjordan.com/animation-counter
export const LikeCounter = props => {
	// Counter variable
	const [likes, setLikes] = useState(props.value || 0);
	
	// Animation variable
	const [animationLikes, setAnimationLikes] = useState('initial');

	// Function
	const handleLikes = () => {
		// 1. Old number goes up
		setTimeout( () => setAnimationLikes('goUp'), 0 );
		// 2. Incrementing the counter  
		setTimeout( () => setLikes(likes + 1), 100 );
		// 3. New number waits down  
		setTimeout( () => setAnimationLikes('waitDown'), 100 );
		// 4. New number stays in the middle
		setTimeout( () => setAnimationLikes('initial'), 200 );
	}
	
	return (
		<div className='switch-label' onClick={handleLikes}>
			❤️ <span className={animationLikes}>{likes}</span>
		</div>
	);
}


export const PageView = PageView_;
export const TreeView = TreeView_;
export const LogView = LogView_;
export const TableView = TableView_;

// ---------------------------------------------------------------------------- UI export
const UI = {
	F1,
	F2,
	F3,
	F4,
	TableView,
	Code,
	HeaderBar,
	CloseButton,
	UIDateTime,
	UIPlayTime,
	Counter,
	UICounter,
	UIView,
	Version,
	DebugView,
	LogView,
	StatusBar,
	NumPad,
	VideoPlayer,
	Image,
	Log,
	Group,
	Loading,
	Spinner,
	Backdrop,
	Dummy,
	Rating,
	Modal,
	Dialog,
	HSplit,
	VSplit,
	Box,
	ABox,
	HBox,
	VBox,
	Icon,
	IconButton,
	Button,
	Label,
	Checkbox,
	Switch,
	// DateTime,
	ButtonBar,
	InputItem,
	InputSelect,
	InputAction,
	ValueItem,
	LabelItem,
	PlayTime,
	Progress,
	DropDown,
	Select,
	Countdown,
	Slider,
	DragView,
	OptionGroup,
	TabView,
	PageView,
	ListView,
	ScaleView,
	LikeCounter,
	SwitchLabel,
	TreeView,
}
export default UI;


//----------------------------------------------------------------------------- parseCSS
const parseCSS = value => {
	return value && (typeof value === 'number'? value+'px' : value);
}


//----------------------------------------------------------------------------- getStyles
/*
	fullWidth = 100%
	size = fontSize
*/

const getStyles = props => {
	if (!props) return null;
	let pos = props.position && ['t','r','b','l'].map(e => (props.position.indexOf(e) > -1)? 0 : null);

	return {
		width		: (props.full || props.fullWidth)? '100%' : parseCSS(props.width),
		height		: (props.full || props.fullHeight)? '100%' : parseCSS(props.height),
		margin		: parseCSS(props.margin),
		padding		: parseCSS(props.padding),
		position 	: props.position && 'absolute',
		top			: pos && pos[0],
		right		: pos && pos[1],
		bottom		: pos && pos[2],
		left		: pos && pos[3],
		fontSize	: parseCSS(props.size),
		background	: props.background,
		color		: props.color,
		flex		: props.flex === true? 1 : props.flex,
		flexDirection : props.column === true? 'column' : null,
		flexWrap	: props.wrap === true? 'wrap' : props.wrap,
		gap			: props.gap,
		borderRadius: props.rounded? '100px' : parseCSS(props.radius),
		border		: props.border && (typeof props.border === 'number'? props.border+'px solid' : props.border),
		overflowY	: props.scroll? 'auto' : 'hidden',
		justifyContent : props.center? 'center'
			: props.space? 'space-between'
			: props.left? 'flex-start'
			: props.right? 'flex-end'
			: null,

		...props.style
	}
}
